import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';

function CourseModal({ open, onClose, onAdd, existingTitles }) {
  const [title, setTitle] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setTitle('');
      setError('');
      setLoading(false);
    }
  }, [open]);

  const handleAdd = async () => {
    if (!title.trim()) {
      setError('Title is required');
      return;
    }
    if (existingTitles.includes(title.trim())) {
      setError('A course with this title already exists');
      return;
    }
    setLoading(true);
    const { data, error: addError } = await supabase
      .from('courses')
      .insert({ name: title.trim() })
      .select('id')
      .single();
    setLoading(false);
    if (addError) {
      setError('Failed to add course');
    } else if (data && data.id) {
      onAdd(data.id);
    }
  };

  if (!open) return null;
  
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ background: '#fff', borderRadius: 10, padding: 32, minWidth: 320, boxShadow: '0 2px 16px #0003', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>&times;</button>
        <h2 style={{ marginTop: 0 }}>Add Course</h2>
        <input
          type="text"
          value={title}
          onChange={e => { setTitle(e.target.value); setError(''); }}
          placeholder="Course Title"
          style={{ width: '100%', padding: 10, fontSize: 16, borderRadius: 6, border: '1px solid #ccc', marginBottom: 16 }}
          disabled={loading}
        />
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        <button
          onClick={handleAdd}
          disabled={loading}
          style={{ width: '100%', padding: 12, background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          {loading ? 'Adding...' : 'Add Course'}
        </button>
      </div>
    </div>
  );
}

export default CourseModal; 